// Generated by ServiceInterfaceGenerator Mar 12, 2020 3:10:53 PM
import { sharedReactorWebsocket as ws } from '../reactor.js';

class SAMLServiceInterface {
  constructor() {
    this.service_id = 'samlservice-1_0';
  }

  /*
    TenancySAMLOptionsByURLRequest = {
      url: String,
    }
     Response type: TenancySAMLOptionsByURLResponse
  */
  getSAMLOptions(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'TenancySAMLOptionsByURLRequest', request, success_callback);
  }

  /*
    TenancySAMLOptionsRequest = {
      tenancyId: int,
    }
     Response type: TenancySAMLOptionsResponse
  */
  getTenancySAMLOptions(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'TenancySAMLOptionsRequest', request, success_callback);
  }

  /*
    CreateSAMLOptionAction = {
      tenancyId: int,
    }
     Response type: CreateSAMLOptionResponse
  */
  createSAMLOption(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateSAMLOptionAction', request, success_callback);
  }

  /*
    UpdateSAMLOptionAction = {
      optionId: String,
      idpMetadataTempFileId: String (Optional),
      autoprovisionUsers: Boolean (Optional),
      enabled: Boolean (Optional),
    }
     Response type: UpdateSAMLOptionResponse
  */
  updateSAMLOption(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateSAMLOptionAction', request, success_callback);
  }

  /*
    SAMLOptionsByEmailRequest = {
      domain: String
    }
     Response type: SAMLOptionsByEmailResponse
  */
  getSAMLOptionsByEmail(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'SAMLOptionsByEmailRequest', request, success_callback);
  }

  /*
    DeviceAuthSAMLOptionsRequest = {
      tenancyId: int,
      includeDisabled: Optional<Boolean>
    }
     Response type: DeviceAuthSAMLOptionsResponse
  */
  getDeviceAuthSAMLOptions(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'DeviceAuthSAMLOptionsRequest', request, success_callback);
  }

  /*
    CreateDeviceAuthSAMLOptionAction = {
      tenancyId: int,
    }
     Response type: CreateDeviceAuthSAMLOptionResponse
  */
  createDeviceSAMLOption(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'CreateDeviceAuthSAMLOptionAction', request, success_callback);
  }

  /*
    UpdateDeviceAuthSAMLOptionAction = {
      optionId: String,
      idpMetadataTempFileId: String (Optional),
      enableForAllMeetings: Boolean (Optional),
      enabled: Boolean (Optional),
    }
     Response type: UpdateDeviceAuthSAMLOptionResponse
  */
  updateDeviceSAMLOption(request, success_callback) {
    return ws.sendServiceRequest(this.service_id, 'UpdateDeviceAuthSAMLOptionAction', request, success_callback);
  }
}

export const samlService = new SAMLServiceInterface();


//////////////////
// WEBPACK FOOTER
// ../ReactorJSCore/dist/services/samlservice.js
// module id = H5qG
// module chunks = 1 2 3 4